import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';

export function TvControllersTabs({ value }: { value: 'list' | 'groups' }) {
  const navigate = useNavigate();
  return (
    <Tabs
      value={value}
      onValueChange={(next) =>
        navigate(
          next === 'groups' ? '/tv-controllers/groups' : '/tv-controllers'
        )
      }
    >
      <TabsList>
        <TabsTrigger value="list" className="px-4">
          Controllers
        </TabsTrigger>
        <TabsTrigger value="groups" className="px-4">
          Groups
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
